import 'jquery';
import Swiper from 'swiper/dist/js/swiper';
import onDocumentReady from '../util/onDocumentReady';

onDocumentReady(() => new Swiper('.about-director__wrap .swiper-container', {
    speed: 600,
    slidesPerView: 1,
    autoHeight: true,
    navigation: {
        nextEl: '.about-director-control__button--next',
        prevEl: '.about-director-control__button--prev',
    },
    autoplay: {
        delay: 5000,
    },
}));
